var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-survey-meta-positive-activity"},[_c('Table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.surveyAnalysisTabels},scopedSlots:_vm._u([{key:"competency",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(_vm.getCompetencyName(row.id)))])]}},{key:"avarage",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.getRateAverage(index)))])]}},{key:"positive",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.getPositivePer(index)))])]}},{key:"one",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.getActivityLabel(row.id, 0)))])]}},{key:"two",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.getActivityLabel(row.id, 1)))])]}},{key:"three",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.getActivityLabel(row.id, 2)))])]}},{key:"four",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.getActivityLabel(row.id, 3)))])]}},{key:"five",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('span',[_vm._v(_vm._s(_vm.getActivityLabel(row.id, 4)))])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }